import React, {useState, useEffect, useRef} from "react";
import socket from "../../services/socket"; 
import useRTC from "../../hooks/useRTC";
import Icons from "../../helpers/icons";
import Text from "../../helpers/text";

import VideoCard from "./videoCard";
import TrackMuteButton from "./trackMuteButton";

export default function Call(props){

    const [localIsSetup, setIsSetup] = useState(false);
    const [stream, setStream] = useState(null);
    const rtc = useRTC(socket);

    const videoRef = useRef(null);
    //const canvasRef = useRef(null);
    //const video = document.createElement( 'video' );

    function _endCall(){
        rtc.disconnect();
        window.location = "/"
    }

    function copyChannelToClipboard() {
        var copyText = document.getElementById("channel-id");
        
        /* Select the text field */
        copyText.select(); 
        copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        navigator.clipboard.writeText(copyText.value);
        copyText.blur();
    }

    useEffect( () => {
        if (!localIsSetup) {
            navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then(s => {
                setStream(s)
                videoRef.current.srcObject = s
                // if (canvasRef != null) {
                //     const ctx = canvasRef.current.getContext('2d');
                //     ctx.drawImage(videoRef.current, 0, 0, 100, 100);
                // }

                rtc.addStream(s);
                socket.emit("join_room", props.match.params.id);
            })

            setIsSetup(true)
        }
    }, [localIsSetup, stream, rtc, props.match.params.id])

    return(
        <main className="call">
            <div className="overlay">
                <div className="top">
                    <button className="channel btn" onClick={copyChannelToClipboard} title={Text.actions.copyChannel}>
                        <img src={Icons.channel} alt="End Call" width="30" height="30"/>
                        <div className="info">
                            <p className="name">{props.match.params.id}</p>
                            <p className="socket">{socket.id}</p>
                            <input id="channel-id" value={"https://video-box.netlify.app/c/" + props.match.params.id} readOnly hidden />
                        </div>
                    </button>
                </div>

                <div className="controls">
                    <div className="tracks">
                        {stream != null ? stream.getTracks().map((t, i) => <TrackMuteButton key={i} track={t} />) : "" }
                    </div>

                    <button className="btn btn-destroy" onClick={ _endCall } title={Text.actions.leaveCall} >
                        <img src={Icons.endCall} alt="End Call" width="30" />
                        <span className="hidden">{Text.actions.leaveCall}</span>
                    </button>
                </div>
            </div>

            <div className="others">
                <VideoCard stream={rtc.outStream} />
            </div>

            <div className="vid-local">
                <video ref={videoRef} autoPlay playsInline muted></video>
                {/* <canvas ref={videoRef}></canvas> */}
            </div>
        </main>
    )
}